import { Tooltip } from "reactstrap";
import React, { useState } from "react";

import { emptyString, MAX_CHAR_LIMIT } from "../../../constants";
import ReactMarkdownComponent from "../../../../../shared/components/reactMarkdownComponent/reactMarkdownComponent";

const LastMessageComponent = ({ conversation }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  //Toggle tooltip
  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };

  return (
    <h6
      className={`message-text my-2 ${
        conversation.hasUnreadMessages || conversation?.isNew
          ? emptyString
          : "opacity-75"
      }`}
      id={`tooltip-${conversation.id}`}
    >
      <ReactMarkdownComponent message={conversation.message || emptyString} />
      {conversation?.message?.length > MAX_CHAR_LIMIT && (
        <Tooltip
          flip={true}
          autohide={true}
          toggle={toggleTooltip}
          placement="auto"
          isOpen={tooltipOpen}
          target={`tooltip-${conversation.id}`}
          popperClassName="disable-link"
          className="text-start"
        >
          <ReactMarkdownComponent
            message={conversation.message || emptyString}
          />
        </Tooltip>
      )}
    </h6>
  );
};

export default React.memo(LastMessageComponent);
